module.exports = __webpack_public_path__ + "img/Objet dynamique vectoriel4-06.a42634b0.png";